﻿import React from 'react';
import Lottie from 'lottie-react';
import useIntersection from '../useIntersection';

import bgAnimData from '../../../../AnimationFiles/footerbg_bigscreen_animation.json';
import BottomText from '../Texts/BottomText';

const FooterBgAnimation = (props) => {

    const ref = React.useRef();
    const lottieRef = React.useRef();
    const inViewport = useIntersection(ref, "-500px");

    React.useEffect(() => {
        if (inViewport === true) {
            if (lottieRef && lottieRef.current) {
                lottieRef.current.play();
            }
        } else {
            if (lottieRef && lottieRef.current) {
                lottieRef.current.pause();
            }
        }
    }, [ref, inViewport])


    return (
        <footer className="car-insurance-campaign__section car-insurance-campaign__section--stacked car-insurance-campaign__footer" ref={ref}>
        <Lottie
            autoplay={false}
            loop={true}
            animationData={bgAnimData}
            lottieRef={lottieRef}
         />
            <BottomText heading={props.heading} text={props.text} buttonText={props.buttonText} buttonLink={props.buttonLink} finePrint={props.finePrint} />
        </footer>
     )
 }                

export default FooterBgAnimation;